// extracted by mini-css-extract-plugin
export var animationContainer = "_gw-0";
export var asteriskIcon = "_gw-8";
export var conversationLeftSection = "_gw-4";
export var conversationListItem = "_gw-3";
export var conversationMiddleSection = "_gw-5";
export var conversationRightSection = "_gw-6";
export var detailsContent = "_gw-1";
export var listContainer = "_gw-7";
export var modalContent = "_gw-2";